export default {
  add_expert_report: 'Add expert report',
  menu: 'Admin',
  menu_login: 'Log in',
  menu_logout: 'Log ut',
  loginLatest_header: 'Latest login',
  details: 'Details',
  user_edit: 'Edit user',
  first_name: 'First name',
  last_name: 'Last name',
  username: 'User name',
  username_enter: 'Type user name',
  password: 'Password',
  password_enter: 'Enter your password',
  password_change: 'Change password',
  password_confirm: 'Confirm password',
  password_mismatch: 'Passwords do not match',
  password_wrongFormat:
    'Does not comply with password policy (min. 6 characters with at least one digit)',
  teamprofile_change: 'Team profiles',
  email: 'E-mail address',
  language: 'Language',
  company: 'Company',
  credits: 'Credits',
  credits_inline: 'credits',
  userDelete_confirmation: 'Do you want to delete the user?',
  userDelete_message: 'The user has been deleted',
  usergroups_header: 'Customers and users',
  usergroup_header: 'Customer',
  usergroup_add_new: 'Add customer',
  usergroup_add_user: 'Add user',
  urlTag: 'URL tag',
  urlTag_feedback: 'Only letters and numbers without spaces',
  customerType_header: 'Type',
  customerType_supplier: 'Supplier',
  customerType_reseller: 'Reseller',
  customerType_customer: 'Customer',
  customers_header: 'Customers',
  orgNumber: 'Org. number',
  orgNumberFormat: 'Format: {format}',
  logoChoice: 'Choose a picture {logo}',
  groupDelete_confirmation: 'Do you want to delete the group?',
  groupDelete_message: 'The group has been deleted',
  groupDelete_error_message:
    'The group could not be deleted. Make sure it is empty first',
  testmethods_header: 'Test methods',
  testmethod_header: 'Test method',
  testmethod_add_header: 'Add test method',
  testmethod_unsupported_info: 'The selected test method is not yet supported for generating team reports.',
  testmethodDelete_confirmation: 'Do you want to delete the test method?',
  testmethodDelete_message: 'The test method has been deleted',
  my_testmethod_header: 'My test method',
  my_testmethods_header: 'My test methods',
  my_testmethods_add_new: 'Add new test method',
  standard_testmethods_header: 'Standard',
  testbuilder_testmethods_header: 'Psytest Builder',
  testbuilder_used_for: 'For Psytest Builder',
  custom_testmethods_question_format: 'Question format',
  custom_testmethods_estimated_time: 'Estimated total time',
  custom_testmethods_estimated_time_info:
    'The estimated time it takes to do the test (in minutes).',
  custom_testmethods_available_scales: 'Available scales',
  custom_testmethods_added_scales: 'Added scales',
  isUsedForTestBuilder_label: 'Used in Psytest Builder',
  error_scales_count: 'Choose at least three scales',
  scale: 'Scale',
  scales_header: 'Scales',
  scale_header: 'Edit scale',
  scale_add_header: 'Add scale',
  scale_langDetail_header: 'Descriptions',
  scaleDelete_confirmation: 'Do you want to delete the scale?',
  scaleDelete_message: 'The scale has been deleted',
  translationDelete_confirmation: 'Do you want to delete the translation?',
  translationDelete_message: 'The translation has been deleted',
  scaleQuestionsHandle: 'Edit questions',
  scaleQuestions_header: 'Edit questions',
  scaleQuestionFormatRequired_message: 'Question format must be set',
  scaleQuestionsUploadImage: 'Upload image',
  scaleQuestionsAlternativeAdd: 'Add alternative',
  scaleQuestionsAdd: 'Add question',
  scaleQuestionsDelete: 'Delete question',
  scaleQuestionsAnswer: 'Answer',
  scaleQuestionsCorrectAnswer: 'Correct answer',
  scaleIsRandomizedLogicTest: 'Randomized logical test',
  numericalImageType_header: 'Type',
  logicTestLevel_desc: 'Level',
  instructions_header: 'Instructions',
  instruction_add_header: 'Add instruction',
  instruction: 'Instruction',
  instruction_disable_question: 'Do not use question',
  pageIndex_header: 'Page {page}',
  exerciseQuestion: 'Exercise question',
  isStandardInstruction: 'Use as standard instruction',
  correctAnswerMessage: 'Correct answer',
  incorrectAnswerMessage: 'Incorrect answer',
  noAnswerMessage: 'No answer',
  page: 'Page',
  addPage: 'Add page',
  pageDelete_confirmation: 'Do you want to delete the page?',
  instructionDelete_confirmation: 'Do you want to delete the instruction?',
  instructionDelete_message: 'The instruction has been deleted',
  instruction_exerciseQuestion_header: 'Exercise question',
  instruction_answerMessages_header: 'Response messages',
  lowEndDescription: 'Description low level',
  highEndDescription: 'Description high level',
  lowEndCoachingDescription: 'Coaching description low level',
  highEndCoachingDescription: 'Coaching description high level',
  status_header: 'Status',
  questionFormat_header: 'Question format',
  pdfType_header: 'Pdf-type',
  creditCost_header: 'Credit cost',
  credits_header: 'Credits',
  credits_feedback: 'Credit must be filled in as a numeric value',
  evaluation_label: 'For evaluation',
  excelExportEnabled_label: 'Allow Excel export',
  lsiCoachingAvailable_label: 'LSI coaching available',
  isActive: 'Active',
  isLimited: 'Time limited test',
  imageBank: 'Image bank',
  imageBankGetImage: 'From image bank',
  imageBankAddFolder: 'Add folder',
  imageBankAddImage: 'Upload image',
  folder: 'Folder',
  credits_error_feedback: 'Credit costs must be filled in as a numeric value',
  availableNormgroups_header: 'Available normgroups',
  normgroup: 'Norm group',
  normgroups_header: 'Norm groups',
  normgroup_edit_header: 'Edit norm group',
  normgroup_confirmation: 'Do you want to delete the norm group?',
  normgroup_message: 'The norm group has been deleted',
  normgroup_add_new: 'Add new norm group',
  testsuite_create: 'Create test suite',
  testsuite_type: 'Choose test type',
  testsuite_header: 'Test suite',
  testsuite_create_header: 'Create new test suite',
  testsuite_tests: 'Tests',
  testsuite_info: 'Info',
  testsuite_participants: 'Test participants',
  testsuite_expiration_date: 'Expiration date',
  testsuite_group_customer: 'Tag',
  testsuite_add_participant: 'Add participant',
  testsuite_added_participants: 'Added test participants',
  testsuite_unsaved_participants_feedback:
    'You have entered an unsaved participant. Do you wish to add him/her to the test suite?',
  testsuite_no_participants_feedback:
    'You need to add at least one participant to the test suite.',
  testsuite_invalid_participant_feedback: 'Failed to add test participant.',
  testsuite_no_link_added: "Please add {'{link}'} to the text.",
  testsuite_email: 'E-mail',
  testsuite_at_place: 'At place',
  testsuite_anonymous: 'Anonymous',
  testsuite_alias: 'Alias',
  testsuite_load_email_template: 'Load from template',
  testsuite_email_save_template: 'Save new template',
  testsuite_email_delete_template: 'Delete template',
  testsuite_email_templates: 'Templates',
  testsuite_email_message: 'Message',
  testsuite_email_subject: 'Subject',
  testsuite_included_testmethods: 'Added test methods',
  testsuite_customer_add_new: 'Add new',
  testsuite_customer_load_from_list: 'Choose..',
  testsuite_testmethod_type: 'Type',
  testsuite_email_possible_tags: 'Possible tags',
  testsuite_email_template_deleted: 'The template has been deleted',
  standard_testmethods: 'Standard test methods',
  my_testmethods: 'My test methods',
  customerTag_confirmation: 'Do you want to delete the tag?',
  customerTag_message: 'The tag has been deleted',
  pin: 'PIN',
  testmethodType_standard: 'Standard',
  testmethodType_testbuilder: 'Psytest Builder',
  question_time: 'Time per question',
  test_time: 'Time per test',
  question_time_description:
    'The estimated time it takes to answer one question (in seconds).',
  test_time_description:
    'The estimated time it takes to finish a test (in minutes).',
  testDelete_confirmation: 'Do you want to delete the test?',
  testDelete_message: 'The test has been deleted',
  testDelete_error_message: 'The test could not be deleted',
  my_profile_header: 'My profile',
  transaction_history: 'Search transaction history',
  transaction_start: 'Start date',
  transaction_end: 'End date',
  see_transactions: 'See transactions',
  show_inactive: 'Show inactive',
  stringEMInsufficientCredits:
    'You do not have credits enough to generate the report. Contact your dealer for more information',
  minutes: 'minutes',
  expert_report_header: 'Analyse direct',
  expert_report_cost: 'This report costs an additional {credits} credits.',
  expert_report_please_select: 'Please select a {selection}.',
  expert_report_type_TeamReport: 'LSI Leadership Style Inventory',
  expert_report_invalid_selection:
    'This Analyse direct report is not available for the current selections.',
  expert_report_invalid_selection_team:
    'This report is not available for the current selections.',
  expert_report_edit_translations: 'Edit translations',
  expert_report_edit_title: 'Edit title',
  expert_report_edit_item_header: 'Edit content',
  expert_report_name_header: 'Report name',
  expert_pdf_report_name_header: 'PDF report name',
  expert_pdf_report_subtitle: 'PDF subtitle',
  expert_report_title_header: 'Title',
  expert_report_description_header: 'Description',
  expert_report_text_header: 'Text',
  expert_report_conditions_header: 'Conditions',
  expert_report_content_header: 'Content',
  expert_report_add_report: 'Add report',
  expert_report_edit_report: 'Edit report',
  expert_report_delete_confirmation: 'Do you want to delete the report?',
  expert_report_delete_message: 'The report has been deleted',
  expert_report_new_text_with_terms: 'New text with terms',
  expert_report_new_header: 'New header',
  expert_report_new_subheader: 'New sub header',
  expert_report_select_header: 'Place under heading: ',
  expert_report_select_subheader: 'Place under heading: ',
  expert_report_formulas: 'Formulas',
  expert_report_formulas_and: 'and',
  expert_report_formulas_and_operator: '&&',
  expert_report_formulas_or: 'or',
  expert_report_formulas_or_operator: '||',
  expert_report_formulas_gt: 'greater than',
  expert_report_formulas_gt_operator: '>',
  expert_report_formulas_lt: 'less than',
  expert_report_formulas_lt_operator: '<',
  expert_report_formulas_eq: 'equal to',
  expert_report_formulas_eq_operator: '==',
  expert_report_formulas_gteq: 'greater than or equal to',
  expert_report_formulas_gteq_operator: '>=',
  expert_report_formulas_lteq: 'less than or equal to',
  expert_report_formulas_lteq_operator: '<=',
  expert_report_formulas_example:
    '(PÅV == 4 && STR == 4) && (ENE > 8 || ENE == 5)',
  expert_report_formatting: 'Formatting',
  expert_report_formatting_12_BOL_start: '<style="12_BOL">',
  expert_report_formatting_12_BOL_example: 'Size 12 in bold',
  expert_report_formatting_12_BOL_UL_ITA_start: '<style="12_BOL_UL_ITA">',
  expert_report_formatting_12_BOL_UL_ITA_example:
    'Size 12 in bold, underlined and italic',
  expert_report_formatting_end: '</style>',
  usergroup_has_test_interpreter_permissions: 'Interpretation rights',
  testmethod_order_header: 'Question order',
  testmethod_unsorted_warning: 'Unsorted',
  testmethod_randomize: 'Randomize',
  testmethod_isUsedWithoutStaticTexts: 'Hide static texts',
  testdata_header: 'Data export',
  testdata_start_date: 'From:',
  testdata_end_date: 'To:',
  testdata_select_testmethods: 'Choose which tests to export:',
  testdata_date_filter: 'Filtering on start date of test (clear fields for all tests)',
  testdata_export: 'Export'
}
